import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import React from "react";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {GNWP_SOURCES} from "../../../sdk/src/components/external_links/external_links_consts";
import {Check} from "@sparkware/app-utils";
import {
    IAboutComponentDisplayParams
} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/about-component-params";
import {AboutBox} from "./boxes/about.box";
import { AboutInfoSectionBox } from "./boxes/about-info-section.box";
import { AboutFooterSectionBox } from "./boxes/about-footer-section.box";

export interface AboutComponentProps extends IAboutComponentDisplayParams {
    dialogHandler: IModalDialogHandler;
}

export class AboutComponent extends OrbitComponent<AboutComponentProps> {

    componentDidMount() {
        super.componentDidMount();
        this.services.analytics.sendAnalytics("Client_About", "Open");
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.services.analytics.sendAnalytics("Client_About", "Close");
    }

    private _handleHelpTextClick = () => {
        this.services.analytics.sendAnalytics("Client_About", "Help");
        this.services.externalLinks.openLink({
            source: GNWP_SOURCES.HELP,
            view: "window"
        });
    }

    private _renderHelpText = () => {
      // In CGP there was some other condition which prevented us from showing this part:
      // this.serviceFactory.regulationService().showHelpInAboutWindow
      // However, it was always true, so I think we can safely omit it.
      if (this.services.miniOrbit.isEnabled) {
          return null;
      }

      return (
        <AboutFooterSectionBox onClick={this._handleHelpTextClick}>
            {this.services.translation.translate("ABOUT_HELP_SUPPORT")}
        </AboutFooterSectionBox>
      );
    };

    private _renderAboutInfoSection(sectionTitleKey: string, value: string, valueClass?: string) {
        if (!Check.isEmpty(value)) {
            return (
            <AboutInfoSectionBox>
                <div>{this.services.translation.translate(sectionTitleKey)}</div>
                <div className={valueClass || ''}>{value}</div>
            </AboutInfoSectionBox>
            );
        }
        return null;
    }

    render() {
        return (
          <AboutBox className={"cy-cgp-about-area"}>
              {this._renderAboutInfoSection("ABOUT_SUPPORT_ID_TITLE", this.services.user.cid)}
              {this._renderAboutInfoSection("ABOUT_FISCAL_CODE_TITLE", this.props.fiscalCode)}
              {this._renderAboutInfoSection("ABOUT_OPEN_SESSION_TITLE", this.props.openSessionsBalance, "cy-about-session-balance-amount")}
              {this._renderAboutInfoSection("ABOUT_CLIENT_VERSION_TITLE", this.props.clientVersion)}
              {this._renderHelpText()}
          </AboutBox>
        );
    }
}